import "./styles.css";
import { ThemeProvider } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import Intro from "./components/Intro.js";
import Home from "./components/Home.js";
import theme from "./components/theme.js";
import { CacheProvider } from "@emotion/react";
import * as Constants from "./components/config/config.js";
import * as Globals from "./components/config/GLOBALS.js";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useNavigate } from "react-router-dom";
import createCache from "@emotion/cache";
import jwt_decode from "jwt-decode";
import actions from "./components/actions";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

function App() {
  const [currentLang, setCurrentLang] = useState(Constants.LANG);
  const [notAllowed, setNotAllowed] = useState(false);

  const [mainPage, setMainPage] = useState(
    (window.location.href.split("https://")[1].split(".")[0] == "govis" ||
      window.location.href.split("https://")[1].indexOf("www.govis.ai") != -1) &&
      window.location.href.indexOf("2053") == -1
      ? true
      : true
  );

  const [underConstruction, setUnderConstruction] = useState(
    window.location.href.indexOf("2053") != -1 || mainPage ? false : false
  );

  useEffect(() => {
    if (Constants.MODE == "TEST") {
      setNotAllowed(false);

      return 1;

      /*
      const getIp = async () => {
        // Connect ipapi.co with fetch()
        const response = await fetch("https://ipapi.co/json/");

        const data = await response.json();
        console.log(data);

        // Set the IP address to the constant `ip`
        return data.ip;
      }
      */

      getIp().then((result) => {
        if (result.indexOf(Globals.TEST_ALLOW_IP) == -1) {
          alert("Not Allowed");
          window.location.href = "https://govis.ai";
          setNotAllowed(true);
        }
      });
    } else {
      if (!mainPage) window.location.href = "https://govis.ai";
    }
  });

  // TEMPORARY: Display the Australia website on the main homepage.
  // Set this to false to restore your original homepage.
  const enableAustraliaIframe = true;

  const showAustralia =
    enableAustraliaIframe &&
    ["govis.ai", "www.govis.ai"].includes(window.location.hostname) &&
    window.location.pathname === "/";

  if (showAustralia) {
    return (
      <iframe
        src="https://australia-visitor-visa.govis.ai/"
        title="Australia Visitor Visa"
        style={{
          position: "fixed",
          inset: 0,
          width: "100%",
          height: "100%",
          border: 0,
          display: "block",
          backgroundColor: "#fff",
          zIndex: 9999,
        }}
      />
    );
  }

  // Original display remains active for other paths.
  return (
    <div>
      {!underConstruction && !notAllowed && currentLang == "he" && (
        <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={theme}>
            <div className="App" dir={currentLang == "he" ? "rtl" : ""}>
              <div>
                <Home mainPage={mainPage} />
              </div>
            </div>
          </ThemeProvider>
        </CacheProvider>
      )}

      {!underConstruction && !notAllowed && currentLang == "en" && (
        <ThemeProvider theme={theme}>
          <div className="App" dir={currentLang == "he" ? "rtl" : ""}>
            <div>
              <Home mainPage={mainPage} />
            </div>
          </div>
        </ThemeProvider>
      )}

      {underConstruction && (
        <p>
          We have upgraded our service and website UI, Please visit
          https://govis.ai
        </p>
      )}
    </div>
  );
}

export default App;

// Original OAuth client ID comment:
//416913523020-skl8c263bg31buo05lh3cj6sc02560k0.apps.googleusercontent.com

// [OAuth client secret removed]